import { render, staticRenderFns } from "./MainGlobe.vue?vue&type=template&id=8554d008&"
import script from "./MainGlobe.vue?vue&type=script&lang=js&"
export * from "./MainGlobe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports